import React, { PureComponent } from 'react'
import {
  func, shape, string, bool,
} from 'prop-types'
import Button from '@active/react-ui/Button'
import Form from '@active/react-ui/Form'

import { withI18n } from '@active/react-utils/i18n'
import DefaultComponentLayout, { ErrorContent, LayoutContent } from '../common/Layout'
import I18nMessage from '../common/I18nMessage'
import ConfirmedPassword from '../common/ConfirmedPassword'
import ResetPWDExpired from './components/ResetPWDExpired'
import ResetPWDConfirm from './components/ResetPWDConfirm'
import { generateServices } from '../../shared/service'
import { resetPasswordServiceConfig } from '../../widgets/shared/config'

import './ResetPassword.scss'

class ResetPassword extends PureComponent {
  static propTypes = {
    i18n: func.isRequired,
    token: string,
    handleResetPwdSuccess: func,
    services: shape({
      resetPassword: func.isRequired,
    }).isRequired,
    actions: shape({
      resetPwdSuccessCallback: func,
      sentEmailGoBack: func,
    }),
    configureTrack: func.isRequired,
    Header: func,
    expired: bool,
    realm: string,
  }

  static defaultProps = {
    token: undefined,
    handleResetPwdSuccess: undefined,
    Header: null,
    actions: {
      resetPwdSuccessCallback: undefined,
      sentEmailGoBack: undefined,
    },
    expired: false,
    realm: 'active',
  }

  constructor(props) {
    super(props)
    const { expired } = props
    this.state = {
      showResetPWDExpired: expired,
      showResetPWDConfirm: false,
      showSendResetPWD: !expired,
      errorMsg: null,
      countToClose: false,
    }
  }

  componentDidMount() {
    const { configureTrack } = this.props
    configureTrack({
      eventName: 'ResetPassword',
      widget: 'reset_password',
      pageType: 'reset password',
    })
  }

  handleSubmit = values => {
    const {
      services, token, i18n, realm,
    } = this.props
    const params = {
      pwd: values.password,
      token,
    }
    const resetPasswordServices = generateServices(resetPasswordServiceConfig, {
      ...this.props,
      realm: realm || 'active',
    })

    services.resetPassword({
      params: params,
      resolve: ({
        status, loginURL, message, username, countToClose, ...rest
      }) => {
        if (status === 'SUCCESS') {
          resetPasswordServices.refreshPassword({
            params: { username },
            resolve: this.handleSuccess(status, loginURL, message, countToClose, rest),
            reject: this.handleSuccess(status, loginURL, message, countToClose, rest),
          })
        } else if (status === 'FAILURE' && message) {
          if (message === 'expired') {
            this.setState({
              showResetPWDExpired: true,
              showSendResetPWD: false,
            })
          } else if (message === 'PSW_NOT_QUALFIED') {
            this.setState({
              errorMsg: i18n('passport.common.notice.pwdDescription'),
            })
          } else {
            this.setState({
              errorMsg: message,
            })
          }
        } else {
          this.setState({
            errorMsg: message || i18n('passport.error.server.default'),
          })
        }
      },
      reject: ({ message }) => {
        this.setState({
          errorMsg: message || i18n('passport.error.server.default'),
        })
      },
    })
  }

  handleChange = () => {
    this.setState({
      errorMsg: null,
    })
  }

  handleSuccess = (status, loginURL, message, countToClose, rest) => () => {
    const {
      actions: {
        resetPwdSuccessCallback,
      },
    } = this.props

    const handleComplete = resetPwdSuccessCallback ? () => {
      resetPwdSuccessCallback({
        status, loginURL, message, ...rest,
      })
    } : () => {
      if (countToClose) {
        window.close()
      }
      window.location = `${loginURL}`
    }
    this.setState({
      showResetPWDConfirm: true,
      showSendResetPWD: false,
      handleComplete: handleComplete,
      countToClose,
    })
  }

  render() {
    const {
      showResetPWDExpired, showResetPWDConfirm, showSendResetPWD, handleComplete, errorMsg, countToClose,
    } = this.state
    const { Header, ...rest } = this.props

    if (showResetPWDConfirm) {
      return (<ResetPWDConfirm Header={Header} {...rest} handleComplete={handleComplete} countToClose={countToClose} />)
    }

    if (showResetPWDExpired) {
      return (<ResetPWDExpired Header={Header} {...rest} />)
    }

    if (showSendResetPWD) {
      return (
        <DefaultComponentLayout nameSpace="passport__resetPassword" Header={Header}>
          <LayoutContent title message="passport.resetPassword.title" />
          <LayoutContent main>
            {!!errorMsg && <ErrorContent errorMsg={errorMsg} />}
            <Form onSubmit={this.handleSubmit} onChange={this.handleChange}>
              <ConfirmedPassword
                passwordLabel="passport.resetPassword.label.password"
                required
                name="password"
              />
              <Button className="passport__resetpassword__submit-button" submit type="super">
                <I18nMessage id="passport.resetPassword.btn.resetPwdBtn" />
              </Button>
            </Form>
          </LayoutContent>
        </DefaultComponentLayout>
      )
    }

    return (<div />)
  }
}

export default withI18n(ResetPassword)
